import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { pushModal } from '../../Modals/redux/basicActions';
import { ModalType, ModalOptions } from '../../Modals/redux/types';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';

export function usePushModal(
  modalType: ModalType | string
): (params?: ModalOptions['params']) => void {
  const dispatch = useDispatch();

  return useCallback(
    (params: ModalOptions['params'] = {}) => {
      yieldToMain(() => {
        dispatch(pushModal(modalType, { wrapInModal: false, params }));
      });
    },
    [dispatch, modalType]
  );
}
